












































































import { Component, Mixins } from "vue-property-decorator";
import GameMixin, { GameInterface } from "@/components/GameMixins.vue";
import ItemSelection, { item } from "@/components/shared/ItemSelection.vue";
import Undo from "@/components/shared/Undo.vue";
import Difficulty from "@/components/shared/Difficulty.vue";
import {
  edge,
  graph,
  alphabet,
  dijkstra,
  checkValidity,
} from "@/components/paths/Graph";


@Component<Simple>({
  components: {
    ItemSelection,
    Undo,
    Difficulty,
  },
})
export default class Simple extends Mixins(GameMixin) implements GameInterface {
  g: graph = {nVertices:0, nEdges:0, edges:[]};
  origin: number = null;
  sink: number = null;
  oVertex: string;
  sVertex: string;
  currentDifficultyLevel = 1;
  nE = this.edgeNumber(this.currentDifficultyLevel);
  difficultyLevels = 3;

  edgeNumber(currentDifficultyLevel): number {
    switch (currentDifficultyLevel) {
      case 1: {
        return 12;
      }
      case 2: {
        return 20;
      }
      case 3: {
        return 28;
      }
      default: {
        return 12;
      }
    }
  }


  matrix1 = [[0, 1], [0, 4], [1, 2], [1, 3], [2, 3], [2, 5], [3, 4], [3, 5], [3, 6], [4, 7], [5, 6], [6, 7]];
  matrix2 = [[0, 1], [0, 2], [0, 3], [1, 2], [1, 4], [2, 5], [2, 6], [3, 6], [3, 7], [4, 5], [4, 8], [5, 8], [5, 9], [6, 7], [6, 9], [7, 10], [8, 11], [9, 10], [9, 11], [10, 11]];
  matrix3 = [[0, 1], [0, 2], [0, 3], [1, 2], [1, 4], [2, 3], [2, 5], [3, 6], [3, 7], [4, 5], [4, 8], [5, 6], [5, 8], [5, 9], [6, 7], [7, 9], [7, 10], [8, 11], [8, 12], [9, 12], [9, 13], [10, 13], [10, 14], [10, 15], [11, 13], [11, 14], [11, 15], [13, 14]];

  off() {
    document.getElementById("overlay0").style.display = "none";
    document.getElementById("overlay1").style.display = "none";
    document.getElementById("overlay2").style.display = "none";
    document.getElementById("overlay3").style.display = "none";
    document.getElementById("overlay4").style.display = "none";
    document.getElementById("overlay5").style.display = "none";
    document.getElementById("overlay6").style.display = "none";
    document.getElementById("overlay7").style.display = "none";
    document.getElementById("overlay8").style.display = "none";
  }

  on(id: number) {
    document.getElementById(`overlay${id}`).style.display = "block";
    setTimeout(() => {
        this.off();
    }, 3500);
  }

  toggleColor(id: number){
      const index = id - 1;
      const list = document.getElementById(id.toString()).classList;
      if (list[4] == 'sel'){
        document.getElementById(id.toString()).classList.remove('sel');
        document.getElementById(`l_${this.currentDifficultyLevel}_${id}`).style.color = "black"
        this.g.edges[index].selected=false;
      } else {
        document.getElementById(id.toString()).classList.add('sel');
        document.getElementById(`l_${this.currentDifficultyLevel}_${id}`).style.color = "red"
        this.g.edges[index].selected=true;
      }
  }

  changeDifficultyLevel(newLevel: number) {
    this.currentDifficultyLevel = newLevel;
    this.nE = this.edgeNumber(this.currentDifficultyLevel);
    this.start(); 
  }

  removeSelection(){
    for (let i = 1; i <= this.nE; i++) {
      try {
        document.getElementById(i.toString()).classList.remove('sel');
        document.getElementById(`l_${this.currentDifficultyLevel}_${i}`).style.color = "black"
        this.g.edges[i-1].selected=false;
      } catch {
          console.log("not removed")
      }
    }
  }

  isInitialized(): boolean {
    return this.origin !== null;
  }

  start(){
    if(this.nE){
      this.removeSelection();
    }
    let matrix = null;
    switch (this.currentDifficultyLevel) {
      case 1: {
        this.g.nVertices=8;
        this.g.nEdges=12;
        this.g.edges;
        matrix = this.matrix1;
        break;
      }
      case 2: {
        this.g.nVertices=12;
        this.g.nEdges=20;
        this.g.edges;
        matrix = this.matrix2;
        break;
      }
      case 3: {
        this.g.nVertices=16;
        this.g.nEdges=28;
        this.g.edges;
        matrix = this.matrix3;
        break;
      }
      default: {
        matrix = this.matrix1;
        break;
      }
    }
    this.g.edges = [];
    for (let i = 1; i <= this.g.nEdges; i++) {
      const e: edge = {id:i, v1:matrix[i-1][0], v2:matrix[i-1][1], weight:0, selected:false};
      this.g.edges.push(e)
    }
    
    this.origin = Math.floor(this.randomNumber(this.g.nVertices));
    do{
      this.sink = Math.floor(this.randomNumber(this.g.nVertices));
    } while (this.origin == this.sink);

    this.removeSelection;
    this.oVertex = alphabet[this.origin];
    this.sVertex = alphabet[this.sink];
  }

  getSelected(): number[]{
    const sel: number[] = [];
      for (let i = 0; i < this.g.nEdges; i++){
          const index = i + 1;
          const list = document.getElementById(index.toString()).classList;
          if (list[4] == 'sel'){
            sel.push(i);
          }
      }
    return sel
  }

  undo(){
    this.removeSelection();
  }

  
  isCorrect() {
    
    const x = checkValidity(this.g, this.getSelected(), this.origin, this.sink);
    const check = x == 9;
    
    if (!check) {
      this.on(x);
    } else {this.off();}

    const sol: boolean[] = [];
    sol.push((x == 9));
    sol.push((check));
    return sol;
  }
  
  
}


